import { render } from "./truncate.vue?vue&type=template&id=12538a63&ts=true"
import script from "./truncate.vue?vue&type=script&lang=ts"
export * from "./truncate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__